<template>
  <transition name="addLsDistrib">
    <div class="modal-mask" v-if="show">
      <van-row justify="center" class="page-wrapper">
        <div class="place-content-center">
          <van-form>
            <info-message class="apply-loader settings-message">
              {{ $t("popup.addLsDistrib") }}
            </info-message>
            <itserve-input
                v-model="newLsDistrib"
                type="text"
                class="apply-loader"
                :placeholder="$t('popup.lsDistrib')"
                name="lsDistrib"
            />
          </van-form>
          <itserve-button
              type="primary"
              class="itserve-round-btn itserve-button-wide mb-15 apply-loader"
              :value="$t('buttons.saveChanges')"
              @click="addLsDistrib"
          ></itserve-button>
          <itserve-button
              type="default"
              class="itserve-round-btn itserve-button-wide mb-25 apply-loader"
              :value="$t('buttons.close')"
              @click="closeDialog"
          ></itserve-button>
        </div>
        <simple-dialog
            v-model="showDialog2"
            :success="actionSuccessfully"
            :title="dialogMessage"
            @change="confirm"
        />
        <simple-dialog
            v-model="showDialog3"
            :success="actionSuccessfully"
            :title="dialogMessage"
        />
      </van-row>
    </div>
  </transition>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";
import ItserveInput from "@/components/forms/ItserveInput";
import ItserveButton from "@/components/forms/ItserveButton";
import SimpleDialog from "@/components/content/SimpleDialog";
import { Form } from 'vant';

export default {
  name: "addLsDistrib",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.$emit('update:show', false);
      }
    }
  },
  components: {
    ItserveButton,
    ItserveInput,
    InfoMessage,
    SimpleDialog,
    vanForm: Form
  },
  data() {
    return {
      showDialog: false,
      showDialog2: false,
      showDialog3: false,
      dialogMessage: "",
      actionSuccessfully: false,
    };
  },
  computed: {
    newLsDistrib: {
      get() {
        return this.$store.state.Auth.accountNumberLsDistrib;
      },
      set(newLsDistrib) {
        this.$store.commit("Auth/SET_ACCOUNT_NUMBER_LS_DISTRIB", newLsDistrib);
        this.dialogMessage = this.$t("settings.successMessage");
      },
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    addLsDistrib() {
      const lsDistrib = this.$store.state.Auth.accountNumberLsDistrib?.trim();

      if (!lsDistrib || lsDistrib === '') {
        this.showDialog3 = true;
        this.dialogMessage = this.$t("settings.emptyField");
        this.actionSuccessfully = false;
        return;
      }

      this.$store.dispatch("Auth/storeNewAccountLsDistrib", (res) => {
        if (res) {
          this.showDialog2 = true;
        } else {
          this.showDialog2 = true;
          this.dialogMessage = this.$t("settings.error");
        }
      });
    },
    confirm() {
        // Зберігаємо номер рахунку в стейті
        // this.$store.commit("Auth/SET_ACCOUNT_NUMBER_LS_DISTRIB", this.$store.state.Auth.accountNumberLsDistrib);
        // Скидаємо показ діалогів
        // this.showDialog2 = false;
        // this.showDialog3 = false;
      console.log("addLsDistrib confirm", this.$store.state.Auth.accountNumberLsDistrib);
        // Передаем номер счета в родительский компонент
        this.$emit("update:show", false);
        this.$emit("close", this.$store.state.Auth.accountNumberLsDistrib);
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.addLsDistrib-enter {
  opacity: 0;
}

.addLsDistrib-leave-active {
  opacity: 0;
}

.addLsDistrib-enter .modal-container,
.addLsDistrib-leave-active .modal-container {
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
}
</style>
